/**
 * Created by Jie Gao on 2021-06-22.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GGGameConfig} from "../GGGameConfig";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GGParsedGameData} from "../server/data/GGParsedGameData";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GGReelController} from "../reel/GGReelController";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GGReelSymbol} from "../symbols/GGReelSymbol";
import {GGHelper} from "../utils/Helper";

export class GrenadePresentation extends BaseView {
    private _hasWin:boolean = false;
    private _layer:PIXI.Container;
    private _transformData:boolean[][];

    constructor() {
        super();
        this._layer = StageManager.getLayer(GGGameConfig.instance.LAYERS.GOBLINS.name);
    }

    protected initAnimations():void {}

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onGameDataParsed(data:GGParsedGameData):void {
        this._transformData = data.topTrain.goblinSpellTransform;
        this._hasWin = data.singleWin > 0;
    }

    private createFire(x:number):TimelineSprite {
        const fire:TimelineSprite = new TimelineSprite(GameResources.getTextures("grenadeFire"));
        fire.anchor.set(0.5, 0.5);
        fire.x = x + 40;
        fire.y = GGGameConfig.instance.REEL_AREA_TOP + GGGameConfig.instance.REEL_AREA_POS_Y + 40;
        fire.visible = false;
        this._layer.addChild(fire);
        return fire;
    }

    public dropGrenade(reelId:number):TimelineLite {
        if(!this._transformData) {
            return new TimelineLite();
        }

        const speed:number = 2500;
        let duration:number = 0, x:number = 0, endY:number = 0;
        const tl:TimelineLite = new TimelineLite();

        this._transformData[reelId].forEach((hasTransform:boolean, symId:number) => {
            if(hasTransform) {
                const pos:[number, number] = Helper.getSymbolPositions(reelId, symId, true);
                x = pos[0]-50;
                endY = pos[1] - 50;
                const symbol:StateReelSymbol = Reels.getSymbol(reelId, symId)!;
                const transformAnimations:TimelineLite = new TimelineLite();
                const newSym:StateReelSymbol = (<GGReelController>Reels.getReel(reelId)).addTransformedSymbol("W");
                const toNW = GGHelper.createSpineAnimation("M_To_NW");
                duration = endY > 222.5 ? MathHelper.roundToDecimals((endY - 128) / speed, 2) : 0;
                //tl.add(() => (<GGReelView>Reels.getReel(reelId)!.view).addSymbolToWinContainer(symbol, true), 0);
                transformAnimations.add([
                    ()=>{
                        StageManager.getLayer(GGGameConfig.instance.LAYERS.GOBLINS.name).addChild(toNW);
                        toNW.position = GGHelper.copyLocalPosition(toNW,symbol);
                        toNW.state.setAnimation(0, `Size_${(<GGReelSymbol>symbol).symSize}${this._hasWin?"":"_No_Win"}`, false);
                        toNW.visible = true;
                    }],0);
                transformAnimations.add(() => (<GGReelController>Reels.getReel(reelId)).removeTransformedSymbol(newSym, symId), 0.1);
                transformAnimations.add(() => toNW.destroy(), this._hasWin?1.26:0.3);
                tl.add(transformAnimations, duration);
            }
        });

        if(duration > 0) {
            const fire:TimelineSprite = this.createFire(x);
            fire.blendMode = PIXI.BLEND_MODES.ADD;
            tl.add([
                () => {fire.getAnimationAutoShowHide(true, true);},
                TweenLite.to(fire, duration, {y : endY})
            ], 0);
            tl.add(() => this._layer.removeChild(fire), duration);
        }
        return tl;
    }

}